export const COLOR = {
  black: "#000000",
  white: "#fff",
  mainColor: "#07CA4A",
  blue: "#0711F8",
  red: "#E82626",
  yellow: "#FDF7C6",
  grey: "#4C4C4C",
};
